export default __webpack_public_path__ + "static/media/presale_img.47b670c8.webp";